var mobile_user_portal_styles = {
  mobile_user_portal: {
    width: "100%",
    overflowX: "hidden" as const,
    display: "flex",
    justifyContent: "center" as const,
    alignItems: "center" as const,
    flexDirection: "column" as const,
    paddingBottom: "150px",
  },
  form: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center" as const,
    gap: "12px",
    padding: "16px",
    maxWidth: 400,
    boxSizing: "border-box" as const,
  },
  card: {
    width: "95vw",
    flexDirection: "column" as const,
    alignItems: "flex-start",
    borderRadius: "8px",
    border: "1px solid var(--Gray---100, #E8E9EB)",
    background: "var(--White, #FFF)",
    fontFamily: "Montserrat",
    boxShadow: "none",
  },
  top: {
    display: "flex",
    padding: "4px 16px 0px 16px",
    flexDirection: "column" as const,
    alignItems: "flex-start",
    gap: "",
    alignSelf: "stretch",
  },
  status_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
  },
  status_tile_active: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    background: "var(--Green---100, #7AA303)",
    fontFamily: "Montserrat",
    paddingLeft: "10px",
    paddingRight: "10px",
    height: "100%",
    maxHeight: "30px",
  },
  status_tile_cancelled: {
    display: "flex",
    padding: "0px 6px 0px 6px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    background: "var(--Gray---600, #9094A0)",
    fontFamily: "Montserrat",
    paddingLeft: "10px",
    paddingRight: "10px",
    height: "100%",
    maxHeight: "30px",
  },
  status_tile_active_warning: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    background: "var(--Events-Type-Note-100, #EFAC00)",
    fontFamily: "Montserrat",
    paddingLeft: "10px",
    paddingRight: "10px",
    height: "100%",
    maxHeight: "30px",
  },
  status_tile_frozen: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "4px",
    background: "var(--Events-Type-Note-100, #cce6ff)",
    fontFamily: "Montserrat",
    paddingLeft: "10px",
    paddingRight: "10px",
    height: "100%",
    maxHeight: "30px",
  },
  status_headline: {
    color: "var(--White, #FFF)",
    textAlign: "center" as const,
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
  },
  top_text: {
    paddingTop: "20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: "1 0 0",
  },
  membership_name: {
    flex: "1 0 0",
    alignSelf: "stretch",
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    padding: 0,
    margin: 0,
  },
  next_payment_on_date_container: {
    paddingTop: "16px",
    display: "flex",
    height: "24px",
    alignItems: "baseline",
    gap: "4px",
    alignSelf: "stretch",
  },
  npod_label: {
    color: "var(--Gray---800, #4F5467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    padding: 0,
    margin: 0,
  },
  npod_text: {
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    padding: 0,
    paddingBottom: "10px",
    margin: 0,
  },
  cancellation_container: {
    display: "flex",
    padding: "0px 48px 16px 48px",
    flexDirection: "column" as const,
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "8px",
    alignSelf: "stretch",
    borderTop: "1px solid var(--Gray---100, #E8E9EB)",
  },
  cancellation_list: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "flex-start",
    gap: "8px",
    alignSelf: "stretch",
  },
  cancellation_fee_container: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    alignSelf: "stretch",
  },
  cancellation_fee_label: {
    // width: "112px",
    color: "var(--Gray---800, #4F5467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  cancellation_fee_text: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical" as const,
    WebkitLineClamp: "2",
    flex: "1 0 0",
    overflow: "hidden",
    color: "var(--Black---1000, #191924)",
    textOverflow: "ellipsis",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },

  cancel_button: {
    display: "flex",
    height: "40px",
    padding: "8px 16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    alignSelf: "stretch",
    borderRadius: "4px",
    border: "1px solid var(--Red---200, #DC5020)",
    background: "none",
    color: "var(--Red---200, #DC5020)",
  },
  cancel_button_disabled: {
    border: "1px solid var(--Gray---100, #E8E9EB)",
    color: "var(--Gray---600, #9094A0)",
    background: "none",
    display: "flex",
    height: "40px",
    padding: "8px 16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    alignSelf: "stretch",
    borderRadius: "4px",
  },
  alert: {
    borderRadius: "4px",
    background: "var(--Gray---50, #F7F7F7)",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    padding: "12px 12px 12px",
  },
  alert_custom: {
    display: "flex",
    padding: "12px 12px 12px",
    alignItems: "flex-start",
    gap: "12px",
    alignSelf: "stretch",
    borderRadius: "4px",
    background: "var(--Gray---50, #F7F7F7)",
  },
  text_container: {
    display: "flex",
    height: "20px",
    alignItems: "baseline",
    gap: "4px",
    alignSelf: "stretch",
  },
  label: {
    color: "var(--Gray---800, #4F5467)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    padding: 0,
    margin: 0,
  },
  text: {
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    padding: 0,
    paddingBottom: "10px",
    margin: 0,
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "inherit" as const,
    width: "100%",
    paddingTop: "30vh",
  },
  message: {
    textAlign: "center" as const,
    color: "var(--Gray---800, #4F5467)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    padding: "24px 16px",
    margin: 0,
    maxWidth: 400,
  },
};

var accordion_styles = (expanded: any) => {
  return {
    borderTop: expanded ? "1px solid #ccc" : "none",
    "&:before": { display: "none" },
    fontFamily: "Montserrat",
    width: "100%",
    padding: 0,
  };
};

export { accordion_styles };

export default mobile_user_portal_styles;